<template>
  <v-row align="center" justify="center">
    <v-col md="6">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>
          Update user
        </v-card-title>
        <v-card-text>
          <validation-observer ref="validationObserver" slim>
            <user-form :user="user" :validations="validationRules"> </user-form>
          </validation-observer>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="
                $router.push({ name: $routes.admin.user.indexRoute.name })
              "
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="updateUser">
              Update
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { fetchUser, updateUser } from "../../../../api/user.api.js";
import UserForm from "../../../components/user/UserForm.vue";
import ContentLoader from "../../../mixins/ContentLoader.js";
import { ValidationObserver, extend } from "vee-validate";
import { required_if as requiredIf } from "vee-validate/dist/rules.js";
import Validatable from "../../../mixins/Validatable.js";

extend("required_if", requiredIf);

export default {
  name: "UserUpdate",
  components: {
    UserForm,
    ValidationObserver
  },
  mixins: [ContentLoader, Validatable],
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      user: {
        username: null,
        password: null,
        passwordConfirmation: null
      }
    };
  },
  computed: {
    validationRules() {
      return {
        username: "required",
        password: "",
        passwordConfirmation: "required_if:password|confirmed:password"
      };
    }
  },
  async created() {
    this.$startLoading();
    try {
      const response = await fetchUser(this.id);

      this.user = response.data.user;
      await this.$nextTick();
    } catch (e) {
      console.error(e);
    } finally {
      this.$finishedLoading();
    }
  },
  methods: {
    async updateUser() {
      const { validationObserver } = this.$refs,
        isValid = await validationObserver.validate();

      if (isValid) {
        updateUser(this.id, this.user)
          .then(() =>
            this.$router.push({ name: this.$routes.admin.user.indexRoute.name })
          )
          .catch(error => this.handleErrorResponse(validationObserver, error));
      }
    }
  }
};
</script>
